import clsx from "clsx"
import React from "react"

export interface TextAreaProps
  extends React.HTMLAttributes<HTMLTextAreaElement> {
  inputRef?: React.Ref<HTMLTextAreaElement>
  fullWidth?: boolean
  rows?: number
}

const TextArea = ({
  className,
  inputRef,
  fullWidth,
  ...props
}: TextAreaProps) => {
  return (
    <textarea
      ref={inputRef}
      className={clsx(
        "py-4 px-8 text-textNegative placeholder:text-body2 bg-transparent border-[1px] border-[#F5F5F5] rounded-input",
        {
          "w-full": fullWidth,
        },
        className
      )}
      {...props}
    />
  )
}

export default TextArea

export const RefTextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => <TextArea {...props} inputRef={ref} />
)
